export default ["/ContractReporting/"];
